import { useTheme } from '@emotion/react';
import { Button, Dialog, DialogActions, Stack, Typography } from '@mui/material';
import React from 'react';
import FormTextField from '../../../../components/FormTextField';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { Form, Formik } from 'formik';
import { useRef } from 'react';
import * as yup from 'yup';
import { setLoading } from '../../../../redux/features/appSlice';
import appapi from '../../../../api/apiClient';
import { showmessage } from '../../../../utils/toastr';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  remark: yup.string('Remark').required().min(3, 'Remark must be at least 3 characters').max(500, 'Remark must be at most 500 characters').nullable(),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '528px',
    margin: '8px',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100% - 20px)',
  },
};

export default function AcceptAndRejectDialog({ modelOpen, onModelHandleClose, data, type }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  const text = theme.palette.primary.text;
  const {t} = useTranslation()

  const handleAcceptReject = async (values) => {
    dispatch(setLoading(true));
    let payload = {
      ...values,
    };
    const response = await appapi.put(`trader/quoteAcceptOrReject/${data?._id}`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === 'success') {
        showmessage(data?.message);
        onModelHandleClose(true);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      <Stack className="p-[24px]">
        <Typography
          className="fs-16 ff-Roboto fw-medium"
          color={text}
        >
          {type === 'reject' ? ` Confirm KYC Rejection` : ` Confirm KYC Acceptance`}
        </Typography>
        <Typography
          className="fs-14 ff-Roboto fw-regular !mt-[10px]"
          color={text}
        >
          {type === 'reject' ? t('Are you sure you want to reject the KYC?') : t('Are you sure you want to approve the KYC?')}
        </Typography>
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{}}
          validationSchema={validationSchema}
          onSubmit={(values) => {}}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
            <Form autoComplete="off">
              <Stack style={{ width: '480px', marginTop: '20px' }}>
                <FormTextField
                  outlineLabel={t('Remark')}
                  name="remark"
                  multiline={true}
                  maxRows={3}
                  requiredMark={true}
                  inputProps={{ maxLength: 500 }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      minHeight: '72px !important',
                      display: 'block',
                    },
                  }}
                />
              </Stack>
              <DialogActions
                className="!justify-end"
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      '&:hover': {},
                    },
                  ]}
                  style={{ width: '112px', height: '48px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      textTransform: 'uppercase',
                      backgroundColor: type === 'accept' ? '#00A632' : '#CF1010',
                      '&:hover': {
                        backgroundColor: type === 'accept' ? '#00A632' : '#CF1010',
                      },
                    },
                  ]}
                  style={{ width: '112px', height: '48px' }}
                  disabled={!(dirty && isValid)}
                  type="submit"
                  variant="contained"
                >
                  {type === 'reject' ? t('Reject') : t('Accept')}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
